import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { ChevronLeft } from '../../icons';
import { getTestIds } from '../../utils/TestIds';
import { IconButton } from '../IconButton';
import { Spinner } from '../Spinner';
import { Typography } from '../Typography';
import styles from './PageHeader.module.scss';
export const GetPageHeaderTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            PageHeaderTID: {
                BackButton: (testId)=>"".concat(testId, "-back-button"),
                Header: (testId)=>"".concat(testId, "-page-header"),
                Subheader: (testId)=>"".concat(testId, "-page-subheader"),
                Actions: (testId)=>"".concat(testId, "-actions"),
                Loading: 'page-loading'
            }
        }
    });
/** Renders the top content of a page. */ export function PageHeader(props) {
    const { title, subheader, actions, loading, onClickBack, className, hideActions, testId } = props;
    const { PageHeaderTID } = useMemo(()=>GetPageHeaderTID(testId), [
        testId
    ]);
    const shouldShowBackButton = Boolean(onClickBack);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.container, className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.leadingArea, {
                    [styles.backButtonShown]: shouldShowBackButton
                }),
                children: [
                    shouldShowBackButton && /*#__PURE__*/ _jsx(IconButton, {
                        // eslint-disable-next-line custom/no-hardcoded-bi-name-in-seagull -- WHY: PageHeader owns the inherent fixed-semantic "back" nav action; consumers cannot rename it (rule 6a), so the name is hardcoded by design, not a missing pass-through.
                        bi: {
                            name: 'back'
                        },
                        size: "smallMedium",
                        className: styles.backButton,
                        testId: testId && PageHeaderTID.BackButton(testId),
                        onClick: onClickBack,
                        children: /*#__PURE__*/ _jsx(ChevronLeft, {})
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.header,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                as: "span",
                                variant: "h4",
                                weight: "normal",
                                testId: testId && PageHeaderTID.Header(testId),
                                children: title
                            }),
                            loading && /*#__PURE__*/ _jsx(Spinner, {
                                size: 40,
                                testId: PageHeaderTID.Loading()
                            })
                        ]
                    }),
                    subheader && /*#__PURE__*/ _jsx(Typography, {
                        className: styles.subheader,
                        testId: testId && PageHeaderTID.Subheader(testId),
                        children: subheader
                    })
                ]
            }),
            !hideActions && /*#__PURE__*/ _jsx("div", {
                className: styles.actions,
                "data-testid": testId && PageHeaderTID.Actions(testId),
                children: actions
            })
        ]
    });
}
